import { action, observable } from "mobx";
import getWeb3 from '../getWeb3';
import Web3 from 'web3';
class Web3Store {
  @observable web3 = {};
  @observable defaultAccount = '';
  getWeb3Promise = null;
  @observable loading = false;
  @observable errors = [];
  @observable userTokens = [];
  @observable explorerUrl = '';
  @observable startedUrl = window.location.hash
  @observable taskList = '';
  @observable netIdName = '';
  
  constructor(rootStore) {
    
    //jACKY
    if(window.ethereum){
      window.ethereum.on('accountsChanged', accounts => {
        this.setDefaultAccount(accounts[0])
      })
    }
  
    
    this.getWeb3Promise = getWeb3().then(async (web3Config) => {
      const {web3Instance, defaultAccount, netIdName} = web3Config;
      this.defaultAccount = defaultAccount;
      this.getUserTokens(web3Config)
      
      if(!web3Instance){
        throw new Error('请先安装MetaMask')
      }
      
      this.netIdName = netIdName
      this.setExplorerUrl(web3Config.explorerUrl)
      this.web3 = new Web3(web3Instance.currentProvider); 
      console.log('web3 loaded')
    }).catch((e) => {
      console.error(e,'web3 not loaded')
      this.errors.push(e.message)
    })
  }
  
  //jACKY
  async connectWallet(){
    if(!window.ethereum){
      throw new Error('没有安装钱包。请前往 https://metamask.io 安装MetaMask钱包后再返回本页面')
    }
    await window.ethereum.request({ method: 'eth_requestAccounts' });
  }
  
  //jACKY
  @action 
  setDefaultAccount(account){
    this.defaultAccount = account
  }  
  @action
  setTaskList(data){
    this.taskList = data
  }
  
  @action
  setExplorerUrl(url){
    this.explorerUrl = url
  }
  @action
  setStartedUrl(url){
    this.startedUrl = url;
  }
  @action
  addUserToken(symbol, address){
    if(!symbol || !address) return
    for(let i=1;i< this.userTokens.length; i++){
      const t = this.userTokens[i]
      if(t.value.toLowerCase() === address.toLowerCase()){
        return
      }
    }
    this.userTokens.push({value: address, label: `${symbol} - ${address}`})
    
    //update localStorage
    let tokens = JSON.parse(window.localStorage.getItem('tokens'))
    tokens.push({symbol, address})
    localStorage.setItem('tokens', JSON.stringify(tokens))
  }
  
  //jACKY
  getUserToken(address){
    for(let i=0; i< this.userTokens.length; i++){
      const t = this.userTokens[i]
      if(t.value.toLowerCase() === address.toLowerCase()){
        return t
      }
    }
  }  

  async getUserTokens({trustApiName, defaultAccount}) {
    /*
    window.fetch(`https://${trustApiName}.trustwalletapp.com/tokens?address=${defaultAccount}`).then((res) => {
      return res.json()
      
    })*/
    if(!window.localStorage.getItem('tokens')){
      window.localStorage.setItem('tokens', JSON.stringify([]))
    }    
    let tokens = JSON.parse(window.localStorage.getItem('tokens'))
    //console.log('--->', tokens)
    let userTokens = tokens.map( t => ({label: `${t.symbol} - ${t.address}`, value: t.address}))
    userTokens.unshift({
      value: '0x000000000000000000000000000000000000bEEF',
      label: "ETH - 以太币"
    })
    this.userTokens = userTokens;
    //console.log('->', this.userTokens)
    /*
    Promise.resolve({docs: []}) //jACKY
    .then((res) => {
      let tokens = res.docs.map(({contract}) => {
        const {address, symbol} = contract;
        return {label: `${symbol} - ${address}`, value: address}
      })
      tokens.unshift({
        value: '0x000000000000000000000000000000000000bEEF',
        label: "ETH - 以太币"
      })
      this.userTokens = tokens;
      this.loading = false;
    }).catch((e) => {
      this.loading = false;
      console.error(e);
    })
    */
  }

}

export default Web3Store;


// WEBPACK FOOTER //
// ./src/stores/web3Store.js